import LeadMagnetPage from "@/components/LeadMagnetPage";
import VideoAdGuideCover from "@/components/VideoAdGuideCover";

const LmVideoAd = () => (
  <LeadMagnetPage c={{
    path: "/lm/video-ad", tag: "lm-video-ad", leadMagnet: "video-ad",
    eyebrow: "THE PLAYBOOK",
    headline: "Fill out the form and get access to the guide now",
    subtitle: "The Bottom-of-Funnel Ad that Prints Every Time (for Remodelers): the 7-block script, the 20 winning hooks we use on our clients' ads, the B-roll checklist, how to post it, and how to get your video edited for free.",
    coverNode: <VideoAdGuideCover />,
    ctaLabel: "Text me the link now",
    footerLink: { href: "/lm/ad-script-builder", label: "Prefer to have it written for you? Try our free AI script writer →" },
    seoTitle: "Free Guide: The Bottom-of-Funnel Ad that Prints Every Time",
    seoDescription: "Free guide for remodelers: the 7-block video ad script, the 20 winning hooks we use on our clients' ads, the B-roll checklist, how to post it and how to get your video edited for free.",
  }} />
);

export default LmVideoAd;
